<template>
  <el-dialog class="model-dialog" title="选择具体车型" :visible.sync="dialogVisible" width="550px" :close-on-click-modal="false">
    <p class="model-item" :class="{'active':modelIndex===index}" v-for="(item,index) in modelList" :key="index" @click="chooseModel(item,index)">
      {{item.element.carBrandCname}}{{item.diff}}
    </p>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" size="mini" :disabled="disabled" @click="confirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: ['modelList'],
  data() {
    return {
      dialogVisible: false,
      disabled: true, //确认按钮的点击状态
      modelIndex: '',
      modelItem: {} //选择的车型
    };
  },
  watch: {
    'dialogVisible'(val) {
      if (!val) {
        this.disabled = true;
        this.modelIndex = '';
        this.modelItem = {};
      }
    }
  },
  methods: {
    /** 选择具体车型 */
    chooseModel(item, index) {
      this.modelItem = item
      this.modelIndex = index
      this.disabled = false
    },

    confirm() {
      let backData = JSON.parse(JSON.stringify(this.modelItem));
      this.$emit('confirm', backData);
      this.dialogVisible = false
    }
  }
};
</script>

<style scoped>
.model-dialog >>> .el-dialog__header {
  padding: 15px 15px 10px;
}
.model-dialog >>> .el-dialog__body {
  padding: 10px 15px;
}
.model-item {
  font-size: 18px;
  line-height: 40px;
  font-weight: 500;
}
.model-item:hover {
  color: #cb2e32;
  cursor: pointer;
}
.active {
  color: #cb2e32;
  background: rgba(203, 46, 50, 0.1);
}
</style>